<template>
  <el-dialog
      :destroy-on-close="true"
      title="项目共享人员"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="800px"
      append-to-body
      class="share-customer-dialog"
  >
    <!-- 添加客户表单 -->
    <el-form
        ref="customerForm"
        :model="newCustomer"
        :rules="formRules"
        inline
        class="add-customer-form"
    >
      <el-form-item prop="realName">
        <el-input
            v-model="newCustomer.realName"
            placeholder="共享人姓名"
            clearable
            style="width: 160px"
        ></el-input>
      </el-form-item>
      <el-form-item prop="phoneNumber">
        <el-input
            v-model="newCustomer.phoneNumber"
            placeholder="手机号"
            clearable
            style="width: 160px"
        ></el-input>
      </el-form-item>
      <el-form-item prop="emailAccount">
        <el-input
            v-model="newCustomer.emailAccount"
            placeholder="邮箱"
            clearable
            style="width: 250px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAddCustomer">添加</el-button>
      </el-form-item>
    </el-form>
    <!-- 客户列表表格 -->
    <div class="customer-table-section" v-loading="loading">
      <div class="table-title">
        <span>已共享人员 ({{ customerList.length }})</span>
        <el-button type="danger" size="small" @click="handleRemoveCustomer()">批量删除</el-button>
      </div>
      <el-table
          :data="customerList"
          style="width: 100%" @selection-change="rowSelectionChange">
        <el-table-column
            type="selection"
            align="center"
            width="50">
        </el-table-column>
        <el-table-column
            prop="realName"
            :show-overflow-tooltip="true"
            label="项目共享人姓名">
        </el-table-column>
        <el-table-column
            prop="emailAccount"
            :show-overflow-tooltip="true"
            label="邮箱账号">
        </el-table-column>
        <el-table-column
            prop="phoneNumber"
            :show-overflow-tooltip="true"
            label="手机号码">
        </el-table-column>
        <el-table-column
            label="操作"
            width="180">
          <template slot-scope="scope">
            <a><i class="el-icon-delete" style="color: #d54444" @click="handleRemoveCustomer(scope.row)">删除</i></a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {requestProjectShareDelete, requestProjectShareAdd, requestProjectList} from "../api/project";

export default {
  name: "ShareCustomerDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    selectDetail: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    // 邮箱验证
    const validateEmail = (rule, value, callback) => {
      if (value && !/^[\w.-]+@[\w.-]+\.\w+$/.test(value)) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      projectId: "",
      newCustomer: {
        realName: "",
        phoneNumber: "",
        emailAccount: ""
      },
      customerList: [],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      formRules: {
        realName: [{required: true, message: "请输入共享人姓名", trigger: "blur"}],
        phoneNumber: [{validator: validatePhone, trigger: "blur"}],
        emailAccount: [{required: true, message: "请输入邮箱", trigger: "blur"},{ validator: validateEmail, trigger: "blur"}]
      },
      ids: [],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("update:showDialog", val);
      }
    }
  },
  // watch: {
  //   selectDetail: {
  //     handler(newVal) {
  //       if (newVal?.customerList) {
  //         this.customerList = structuredClone(newVal.customerList);
  //       }
  //     },
  //     immediate: true,
  //     deep: true
  //   }
  // },
  mounted() {
    this.getCustomerList()
  },
  methods: {
    getCustomerList() {
      this.loading = true;
      requestProjectList({'query#id':this.selectDetail.projectId}).then(res => {
        if (res?.code === 200) {
          this.loading=false
          this.customerList = res.data?.map(item=>item.shareCustomerInfos)?.flat().filter(item=>item)||[]
        }
      })
    },
    rowSelectionChange(row) {
      this.ids = row.map(item => item.id)
    },
    // 添加客户
    handleAddCustomer() {
      this.$refs.customerForm.validate(valid => {
        if (!valid) {
          this.$messageUi.error('填写参数不规范，请检查');
          return;
        }
        const {realName, phoneNumber, emailAccount} = this.newCustomer;
        let sendData = {
          realName: realName.trim(),
          phoneNumber: phoneNumber.trim(),
          emailAccount: emailAccount.trim(),
        };
        requestProjectShareAdd(this.selectDetail.projectId, sendData).then(res => {
          if (res?.code === 200) {
            this.$messageUi.success(`添加成功！`);
            this.getCustomerList()
            this.$refs.customerForm.resetFields();
          }
        })

      });
    },
    // 移除客户
    handleRemoveCustomer(row) {
      let ids = [];
      if (row?.id) {
        ids=[row.id]
      }else {
        if(this.ids?.length>0){
          ids=this.ids
        }else {
          this.$messageUi.error(`请选择要删除的共享人员！`);
          return
        }

      }
      this.$confirmUi(`确定要删除所选共享人员吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        requestProjectShareDelete(this.selectDetail.projectId, ids).then(res => {
          if (res?.code === 200) {
            this.$messageUi.success(`删除成功！`);
            this.getCustomerList()
          }
        })
      }).catch(() => {
      });

    },
    // 关闭弹窗
    handleClose() {
      this.$emit("update:showDialog", false)
    },
  }
};
</script>

<style scoped>
.share-customer-dialog /deep/ .el-dialog__body {
  padding: 20px 25px;
}

.add-customer-form {
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
}

.add-customer-form /deep/ .el-form-item {
  margin-bottom: 0;
  margin-right: 15px;
}

.customer-table-section {
  border-radius: 6px;
  overflow: hidden;
}

.table-title {
  display: flex;
justify-content: space-between;
  font-weight: 600;
  font-size: 14px;
  color: #303133;
  margin-bottom: 12px;
}

.delete-btn {
  color: #f56c6c;
  font-size: 16px;
}

.delete-btn:hover {
  color: #f78989;
}

.dialog-footer {
  text-align: right;
}
/deep/ .el-table__body-wrapper{
  max-height: 260px!important;
  overflow-y: auto!important;
}
</style>
